"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapConfigToFilterItems = exports.isFilter = exports.transformOperatorIntoOption = exports.formatSubject = exports.createFilterOption = void 0;
const lodash_1 = require("lodash");
const constants_1 = require("../../../constants");
const advancedSearch_1 = require("../advancedSearch");
const createFilterOption = (label, { filterId, categoryId, objectType }) => ({
    id: filterId,
    path: filterId,
    name: label,
    description: label,
    sectionId: categoryId,
    context: { filterId, categoryId, objectType },
    items: [],
    type: constants_1.AdvancedSearchFilterOptionType.SelectableList,
});
exports.createFilterOption = createFilterOption;
const formatSubject = (context, [first, ...items], { value, label, additionalFilters }) => ({
    id: `${context.filterId}-${value}`,
    name: label,
    subject: value,
    subjectLabel: label,
    items: [],
    type: constants_1.AdvancedSearchFilterOptionType.SelectableList,
    additionalFilters,
    ...(items.length ? { items: [first, ...items] } : first),
    context,
});
exports.formatSubject = formatSubject;
const transformOperatorIntoOption = ({ value, label }, { filterId, ...context }, { allowedValues, helperText, inputType, operators }) => ({
    label,
    operator: value,
    context: { filterId, ...context },
    items: allowedValues?.map((item) => ({
        ...item,
        context: { filterId, ...context },
        id: `${filterId}${item.value}`,
        name: item.label,
    })),
    options: allowedValues?.map((item) => ({
        ...item,
        id: item.value,
    })),
    helperText,
    type: value === constants_1.AdvancedSearchOperators.NotExists
        ? null
        : constants_1.INPUT_TYPE_MAP[inputType],
    value: value === constants_1.AdvancedSearchOperators.NotExists
        ? constants_1.AdvancedSearchOperators.NotExists
        : null,
    ...(operators.length > 1 ? { id: `${filterId}${value}`, name: label } : {}),
});
exports.transformOperatorIntoOption = transformOperatorIntoOption;
const isFilter = (value) => {
    if (!(0, lodash_1.isObject)(value))
        return false;
    const { operators, label } = value;
    return !!(operators && label);
};
exports.isFilter = isFilter;
const mapConfigToFilterItems = (config, objectType) => Object.entries(config)
    .filter(([, filter]) => (0, lodash_1.isObject)(filter?.filters) && (0, advancedSearch_1.hasProperties)(filter))
    .reduce((filterItems, [categoryId, { filters }]) => [
    ...filterItems,
    ...Object.entries(filters)
        .filter(([, value]) => (0, exports.isFilter)(value))
        .map(([filterId, filter]) => {
        const { allowedSubjects, operators, label } = filter;
        const context = {
            objectType,
            categoryId,
            filterId,
        };
        const items = operators.map((operator) => (0, exports.transformOperatorIntoOption)(operator, context, filter));
        const [first, ...rest] = allowedSubjects?.subjects?.map((props) => (0, exports.formatSubject)(context, items, props)) || items;
        return {
            ...(0, exports.createFilterOption)(label, context),
            ...(allowedSubjects || !!rest.length
                ? { items: [first, ...rest] }
                : first),
        };
    }),
], []);
exports.mapConfigToFilterItems = mapConfigToFilterItems;
